import React, { Fragment } from "react"
import { connect } from "react-redux";
import withAuth from "../hocs/withAuth"
import { fetchRegisterClientIds, fetchFBTokens } from "../store/actions/assignments";
import { fetch } from "../store/actions/brand";
import  ChoosePlan  from "../components/membershipPlan/choosePlan"

class MembershipPlanContainer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isNCEP: false,
      isAgency: false
    }
  }

  componentDidMount() {
    this.props.fetchBrand().then((res) => {
      this.setState({
        isNCEP: res.isNCEP,
        isAgency: res.isAgency
      })
    });
  }

  render() {

    const { token, isFetchResponse, isNCEP,  isAgency} = this.state;
    const {  user } = this.props;
   
    return (
      <Fragment>
            <ChoosePlan isNCEP={isNCEP}  isAgency={isAgency}  currentUser = { user }></ChoosePlan>
      </Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.currentUser.user,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchClientIds: () => {
      return dispatch(fetchRegisterClientIds());
    },
    fetchToken: () => {
      return dispatch(fetchFBTokens());
    },
    fetchBrand: () => {
      return dispatch(fetch());
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withAuth(MembershipPlanContainer));



// WEBPACK FOOTER //
// ./src/containers/MembershipPlan.js